import styled from '@emotion/styled';
import { WrapText } from '@landsbankinn/prismic';
import { device } from '@landsbankinn/ui';
import React from 'react';
import { FitImage } from '../../components/img/Img';

interface IBox {
  children: React.ReactNode;
  noPadding?: boolean;
  isTable?: boolean;
  center?: string;
}

const Host = styled.div<IBox>`
  display: ${(props) => (props.noPadding ? 'block' : 'flex')};
  flex-flow: column nowrap;
  justify-content: ${(props) =>
    props.center === 'Center' ? 'center' : 'flex-start'};

  padding: ${(props) => (props.noPadding ? 0 : '40px')};
  background-color: ${(props) =>
    !props.noPadding && props.theme.colors.backgroundAlt};
  overflow: hidden;
  ${(props) => props.noPadding && 'margin-bottom: 0'};

  &:nth-child(3) {
    ${(props) => props.noPadding && 'order: 4'};
  }

  &:nth-child(4) {
    ${(props) => props.noPadding && 'order: 3'};
  }

  ${FitImage} {
    @media ${device.tablet} {
      height: 100%;
      object-fit: cover;
      margin-bottom: 0;
    }
  }

  div {
    h2 {
      margin-bottom: 48px;
    }
  }

  @media ${device.tablet} {
    min-height: auto;
    ${(props) => props.noPadding && 'margin-bottom: 0'};
    padding: ${(props) =>
      props.noPadding ? 0 : props.isTable ? '44px 58px' : '84px 58px'};
  }

  @media ${device.ipadPro} {
    min-height: 442px;
    padding: ${(props) => (props.noPadding ? 0 : '44px 36px')};
    ${(props) => props.noPadding && 'margin-bottom: 20px'};
    &:nth-child(3) {
      ${(props) => props.noPadding && 'order: initial'};
    }

    &:nth-child(4) {
      ${(props) => props.noPadding && 'order: initial'};
    }
  }

  @media ${device.desktop} {
    min-height: 570px;
    padding: ${(props) => (props.noPadding ? 0 : '100px')};
  }
`;

export const Box = ({ children, noPadding, center, isTable }: IBox) => {
  return (
    <Host noPadding={noPadding} center={center} isTable={isTable}>
      {children}
    </Host>
  );
};
